import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

// Styles
import "./404.page.scss";

const NotFound = (): ReactElement => (
  <div className="tm__not-found d-flex flex-column align-items-center justify-content-center text-center h-100">
    <i className="bi bi-emoji-frown text-primary"></i>
    <h1>
      <strong>404</strong> - The requested page was not found.
    </h1>
    <Link className="btn btn-primary fw-bold fs-6 mt-3" to="/">
      Go Home
    </Link>
  </div>
);

export default NotFound;
